import React from "react";

const TeeTimeIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 17.2592 23.3"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.6296,16.917c-4.7571,0 -8.6296,-3.796 -8.6296,-8.459c0,-4.662 3.8725,-8.458 8.6296,-8.458c4.7571,0 8.6296,3.796 8.6296,8.458c0,4.663 -3.8725,8.459 -8.6296,8.459zM8.6296,1.11c-4.1343,0 -7.5013,3.296 -7.5013,7.353c0,4.056 3.3625,7.352 7.5013,7.352c4.1388,0 7.5013,-3.296 7.5013,-7.352c0,-4.057 -3.3625,-7.353 -7.5013,-7.353z"
        fill="currentColor"
      />
      <path
        d="M9.8976,8.458l-1.2637,-0.593l-1.2638,0.593c0,0 0.7357,-5.021 0.8892,-5.353c0.1534,-0.331 0.3701,-0.309 0.3701,-0.309c0,0 0.2211,-0.022 0.3746,0.309c0.1534,0.337 0.8891,5.353 0.8891,5.353z"
        fill="currentColor"
      />
      <path
        d="M12.3755,10.511c0,0 -0.0903,0.199 -0.4785,0.159c-0.352,-0.039 -3.0059,-0.84 -3.5114,-0.995h-0.009c-0.0271,-0.009 -0.0542,-0.018 -0.0632,-0.018c-0.5461,-0.137 -0.9433,-0.623 -0.9433,-1.199c0,-0.685 0.5642,-1.243 1.2638,-1.243c0.3385,0 0.6454,0.133 0.871,0.341c0.0091,0.009 0.0136,0.013 0.0226,0.022c0.2437,0.208 2.5095,2.168 2.7351,2.455c0.2347,0.301 0.1129,0.478 0.1129,0.478z"
        fill="#1A8B5A"
      />
      <path
        d="M12.078,18.585c0,0 -0.7086,0.154 -1.3721,0.703c-0.5867,0.478 -0.9523,1.035 -1.0742,1.783c-0.0677,0.455 -0.3385,2.229 -0.3385,2.229h-1.3269c0,0 -0.2663,-1.769 -0.3385,-2.229c-0.1174,-0.752 -0.483,-1.31 -1.0697,-1.783c-0.668,-0.549 -1.3721,-0.703 -1.3721,-0.703l0.3656,-1.044c0.9659,0.314 2.004,0.486 3.0782,0.486c1.0741,0 2.1122,-0.168 3.0826,-0.486z"
        fill="#1A8B5A"
      />
    </svg>
  );
};

export default TeeTimeIcon;
